export interface IEventMessage {
    type: string;
    [payloadKey: string]: any;
}

abstract class OAuthHandler<TLinkResponse extends { authLink: string }> {
    private _window = {} as Window;
    private _intervalId: any = undefined;
    private _messageHandler?: (event: IEventMessage) => void;
    private _closeInterval = 50;

    public async getCredentials(inputData?: Record<string, any>, isSandbox = false) {
        if (this._messageHandler) {
            window.removeEventListener('message', this._messageHandler, false);
        }

        return new Promise(async (resolve, reject) => {
            let linkResponse: TLinkResponse;
            try {
                linkResponse = await this.createLink(isSandbox, inputData);
            }
            catch (err) {
                reject(err);
                return;
            }

            this._window = window.open(linkResponse.authLink, '', 'width=800,height=600,resizeable,scrollbars') as Window;

            this._messageHandler = (event: IEventMessage) => {
                if (event.data?.type !== 'OAUTH_RESPOSE') {
                    return;
                }
                this._window.close();
                window.removeEventListener('message', this._messageHandler as (event: IEventMessage) => void, false);

                return resolve(this.handleMessagePayload(event, linkResponse, inputData));
            };

            window.addEventListener('message', this._messageHandler, false);

            this._listenToWindowClosed(reject);
        });
    }

    protected abstract createLink(
        isSandbox: boolean,
        inputData?: Record<string, any>,
    ): Promise<TLinkResponse>;

    protected abstract handleMessagePayload(
        event: IEventMessage,
        linkResponse: TLinkResponse,
        inputData?: Record<string, any>,
    ): unknown

    private _listenToWindowClosed(reject: (reason?: any) => void) {
        /** make sure to always clear interval before starting new one */
        clearInterval(this._intervalId);

        this._intervalId = setInterval(() => {
            if (!this._window.closed) {
                return;
            }
            clearInterval(this._intervalId);
            reject(new Error('Authorization interrupted, window was closed before finishing the process'));
        }, this._closeInterval);
    }
}

export default OAuthHandler;
